import { createSlice } from "@reduxjs/toolkit";

const SKIP_AUTH = process.env.REACT_APP_SKIP_AUTH === "true";

const initialState = {
  isAuthenticated: SKIP_AUTH ? true : false,
  auth0Token: SKIP_AUTH ? "dev-skip-auth-token" : null,
  lastTokenUpdateTime: SKIP_AUTH ? Date.now() : null,
};

export const oauthSlice = createSlice({
  name: "oauth",
  initialState,
  reducers: {
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setAuth0Token: (state, action) => {
      state.auth0Token = action.payload;
      state.lastTokenUpdateTime = Date.now();
    },
  },
});

export const { setAuthenticated, setAuth0Token } = oauthSlice.actions;

export default oauthSlice.reducer;
